/* Free-shipping progress bar + honest checkout countdown for the cart drawer.
   Both re-read straight from /cart.js so they stay correct no matter how the
   cart changed (drawer add, quantity edit, line removal, another tab).
   The countdown is a session nudge only — it never implies inventory is being
   held, since Shopify doesn't reserve stock for a cart the way that wording
   would claim. */

function mtCartExtrasRefresh() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      mtUpdateShippingBar(cart);
      mtUpdateCartTimer(cart);
    })
    .catch(function () {});
}

function mtUpdateShippingBar(cart) {
  var bar = document.querySelector('[data-mt-shipping-bar]');
  if (!bar) return;
  // Every order ships free regardless of cart value, so this is a flat
  // reassurance line, not a spend-more-to-unlock progress bar — there is no
  // threshold to track. Just show it whenever the cart has items.
  bar.hidden = cart.item_count === 0;
}

var mtCartTimerInterval = null;

function mtUpdateCartTimer(cart) {
  var el = document.querySelector('[data-mt-cart-timer]');
  if (!el) return;

  if (!cart.item_count) {
    el.hidden = true;
    if (mtCartTimerInterval) clearInterval(mtCartTimerInterval);
    sessionStorage.removeItem('mtCartTimerEnd');
    return;
  }

  el.hidden = false;
  var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
  var stored = sessionStorage.getItem('mtCartTimerEnd');
  var now = Date.now();
  var end = stored ? parseInt(stored, 10) : 0;

  if (!end || end <= now) {
    end = now + minutes * 60 * 1000;
    sessionStorage.setItem('mtCartTimerEnd', String(end));
  }

  mtStartTimerTick(el, end);
}

function mtStartTimerTick(el, endTime) {
  var display = el.querySelector('[data-mt-timer-display]');
  if (mtCartTimerInterval) clearInterval(mtCartTimerInterval);

  function tick() {
    var remaining = Math.max(0, endTime - Date.now());
    var mins = Math.floor(remaining / 60000);
    var secs = Math.floor((remaining % 60000) / 1000);
    if (display) display.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
    if (remaining <= 0) {
      clearInterval(mtCartTimerInterval);
      sessionStorage.removeItem('mtCartTimerEnd');
    }
  }
  tick();
  mtCartTimerInterval = setInterval(tick, 1000);
}

document.addEventListener('DOMContentLoaded', mtCartExtrasRefresh);
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, mtCartExtrasRefresh);
}
